module.exports = __webpack_public_path__ + "img/577.6f30de4e.jpg";